import { render, staticRenderFns } from "./Currencies.vue?vue&type=template&id=336a2bf6"
import script from "./Currencies.vue?vue&type=script&lang=ts"
export * from "./Currencies.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('336a2bf6')) {
      api.createRecord('336a2bf6', component.options)
    } else {
      api.reload('336a2bf6', component.options)
    }
    module.hot.accept("./Currencies.vue?vue&type=template&id=336a2bf6", function () {
      api.rerender('336a2bf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/sale/Currencies.vue"
export default component.exports